import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import {
  ADVERT_FAVORITE_ADD_URL,
  ADVERT_FAVORITE_INIT_URL,
  ADVERT_FAVORITE_REMOVE_URL,
  API_ADVERT_FAVORITE_NAME,
} from '#advertFavorite/constants';
import { FavoriteInitPayloadType, FavoriteInitResponseType } from '#advertFavorite/api';

const getApiAdvertFavorite = (diContainer: Container) => {
  const apiAdvertFavorite = createApi({
    reducerPath: API_ADVERT_FAVORITE_NAME,
    baseQuery: getBaseQuery(diContainer),
    endpoints: (builder) => ({
      init: builder.query<FavoriteInitResponseType, FavoriteInitPayloadType>({
        query: ({ queryParams }) => ({
          url: ADVERT_FAVORITE_INIT_URL,
          params: {
            ...queryParams,
          },
        }),
        serializeQueryArgs: (): null => null,
      }),
      loadMore: builder.query<FavoriteInitResponseType, number>({
        query: (page) => ({
          url: ADVERT_FAVORITE_INIT_URL,
          params: {
            page,
          },
        }),
        serializeQueryArgs: (): null => null,
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          dispatch(
            apiAdvertFavorite.util.updateQueryData('init', undefined, (draft) => {
              draft.adverts.pagination = data.adverts.pagination;
              draft.adverts.items.push(...data.adverts.items);
            }),
          );
        },
      }),
      add: builder.query<void, number>({
        query: (advertId) => ({
          url: ADVERT_FAVORITE_ADD_URL,
          method: 'POST',
          params: {
            advertId,
          },
        }),
      }),
      remove: builder.query<void, number>({
        query: (advertId) => ({
          url: ADVERT_FAVORITE_REMOVE_URL,
          method: 'POST',
          params: {
            advertId,
          },
        }),
      }),
    }),
  });
  return apiAdvertFavorite;
};

export { getApiAdvertFavorite };
